import Vue from 'vue';
import FretePlugin from '@/frete/frete-plugin';

Vue.use(FretePlugin, {
  type: 'COMPRADOR',
});
